import { gatewayClient, createService } from './connectors/httpClient';
import { readCookie } from 'packages/helpers/cookie';
import { createQuery as createQueryGeneric } from 'packages/helpers/queryString';
import { Category } from 'packages/store/categories/types';

export function createQuery(params) {
    const {
        customerId,
        ownershipSource,
        subType,
        system,
        status,
        gallery,
        collectionId,
        assignedToCollection,
        creativeType,
    } = params;
    const safeCustomerId = customerId || readCookie('currentCompany');

    return `type=${gallery ? `GALLERY&type=GALLERY_GLOBAL` : `TEMPLATE`}\
${subType ? `&subType=${subType}` : ''}\
&customerId=${safeCustomerId}\
&ownershipSource=${ownershipSource}\
&system=${system}\
${status ? `&status=${status}` : ''}\
${collectionId ? `&collectionId=${collectionId}` : ''}\
${typeof assignedToCollection !== 'undefined' ? `&assignedToCollection=${assignedToCollection}` : ''}\
${creativeType ? `&creativeType=${creativeType}` : ''}\
&${createQueryGeneric(params)}`;
}

const httpClient = gatewayClient('/creatives');

const templatesService = createService(httpClient, (client) => ({
    fetchTemplates(params) {
        const assignedToCollection = !!params.collectionId || (params.search?.length > 0 ? undefined : false);

        const query = createQuery({ ...params, assignedToCollection });
        const path = `?${query}`;

        return client.get<{ totalItems: number; items: Category[] }>(path);
    },

    fetchTemplate(id: number) {
        return client.get(`/${id}`);
    },

    deleteTemplates(ids: number[]) {
        return client.delete('', { ids });
    },

    duplicateTemplates(ids: number[], collectionId: number) {
        return client.put(`/duplicate`, { ids, collectionId });
    },
}));

export default templatesService;
